import React from 'react'

const AutomationOptionsTime = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="49" viewBox="0 0 36 49" fill="none" className={className}>
    <path
      d="M31.99 9.08V1.5H1.5V9.08C1.50914 10.457 1.81074 11.8162 2.38483 13.0678C2.95891 14.3194 3.79233 15.4348 4.82996 16.34L9.12 20.13L12.87 23.44C13.0653 23.6108 13.2218 23.8214 13.3291 24.0577C13.4364 24.294 13.4918 24.5505 13.4918 24.81C13.4918 25.0695 13.4364 25.326 13.3291 25.5623C13.2218 25.7986 13.0653 26.0092 12.87 26.18L9.12 29.49L4.82996 33.28C3.79233 34.1852 2.95891 35.3006 2.38483 36.5522C1.81074 37.8038 1.50914 39.163 1.5 40.54V48.12H31.99V40.54C31.9834 39.1626 31.683 37.8025 31.1087 36.5505C30.5344 35.2986 29.6996 34.1835 28.66 33.28L24.37 29.49L20.62 26.18C20.4247 26.0092 20.2681 25.7986 20.1608 25.5623C20.0536 25.326 19.9981 25.0695 19.9981 24.81C19.9981 24.5505 20.0536 24.294 20.1608 24.0577C20.2681 23.8214 20.4247 23.6108 20.62 23.44L24.37 20.13L28.66 16.34C29.6996 15.4365 30.5344 14.3214 31.1087 13.0695C31.683 11.8175 31.9834 10.4574 31.99 9.08V9.08Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M1.5 40.51C5.25 38.35 10.69 36.98 16.75 36.98C22.81 36.98 28.24 38.35 31.99 40.51"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomationOptionsTime
